/**
 * Build a WhatsApp share URL. Opens WhatsApp with a prefilled facility summary.
 * Works on mobile (deep-link to app) and web (wa.me / web.whatsapp.com).
 *
 * Design: no decorative emojis — WhatsApp renders bold via *asterisks* and we
 * use spacing / rules for hierarchy so the message reads cleanly in-app AND
 * when copy-pasted into email or a document.
 */
const RULE = "----------------------------------------";

const line = (label, value) => (value ? `${label}: ${value}` : null);

const _mapsLinkFor = (f) => {
  if (f?.maps_link) return f.maps_link;
  if (f?.gps_lat && f?.gps_lng)
    return `https://www.google.com/maps/search/?api=1&query=${f.gps_lat},${f.gps_lng}`;
  return null;
};

export function whatsappShareText(f, opts = {}) {
  const name = (f?.name || "Facility").toUpperCase();
  const category = f?.category
    ? String(f.category).replace(/_/g, " ")
    : null;
  const town = f?.town || null;
  const region = f?.region || null;
  const district = f?.district || null;
  const location = f?.location || null;
  const phones = (f?.phones || []).filter(Boolean).join(", ") || null;
  const plans = f?.nmi_plans_expanded && f.nmi_plans_expanded.length
    ? f.nmi_plans_expanded.join(", ")
    : (f?.nmi_plans || null);
  const email = f?.email || null;
  const hours = f?.working_hours || null;
  const mapsUrl = _mapsLinkFor(f);

  const address = [town, region].filter(Boolean).join(", ") || null;

  const body = [
    opts.alternativeFor ? `Alternative for ${opts.alternativeFor}` : null,
    opts.alternativeFor ? "" : null,
    `*${name}*`,
    category ? category.toUpperCase() : null,
    RULE,
    line("Address", [location, address].filter(Boolean).join(" — ") || address),
    line("District", district),
    line("Phone", phones),
    line("Email", email),
    line("Hours", hours),
    line("Plans accepted", plans),
    mapsUrl ? "" : null,
    mapsUrl ? `Google Maps: ${mapsUrl}` : null,
    "",
    RULE,
    "Nationwide Medical Insurance — HSP Directory",
  ].filter((x) => x !== null && x !== undefined);
  return body.join("\n");
}

export function whatsappShareUrl(f, opts = {}) {
  return `https://wa.me/?text=${encodeURIComponent(whatsappShareText(f, opts))}`;
}

export function shareOnWhatsApp(f, opts) {
  window.open(whatsappShareUrl(f, opts), "_blank", "noopener,noreferrer");
}
